// extracted by mini-css-extract-plugin
module.exports = {"ContentBox":"ContentBox_ContentBox__KfRA4","Title":"ContentBox_Title__2OtEw","Well":"ContentBox_Well__2zPQ3","primary":"ContentBox_primary__2Zj8h"};